export default __webpack_public_path__ + "418f9dd9a33cd3c121ab11a7e454e706.svg";